<template>
  <!-- eslint-disable-next-line vue/no-unused-refs -->
  <base-list-management ref="baseListManagement" :configData.sync="configData">
    <PublicExport
      slot="custom-export"
      v-if="judgePermission('vehicle_list_detail')"
      exportTitle="导出"
      exportTemplate="Tenant"
      :getSearchData="searchParams"
      templateCode="vehicle-workbench-rent-order"
      :getSearchCondition="getSearchCondition"
    />
  </base-list-management>
</template>
<script>
import diffConfigFn from './config'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  name: 'order',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    plateNo: {
      type: String,
      default: '',
    },
  },
  data() {
    const { configData } = diffConfigFn.call(this, 'personalOrder')
    return {
      configData,
      // configData里有引用
      // eslint-disable-next-line vue/no-unused-properties
      customerConditionList: [],
    }
  },
  methods: {
    // 搜索按钮
    // eslint-disable-next-line vue/no-unused-properties
    dealWithData(params) {
      params.carId = this.id
      return params
    },
    searchParams() {
      return {
        ...this.$refs.baseListManagement?.getParams() || {},
        carId: this.id,
      }
    },
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = this.configData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        // 注意：客户下拉列表需要使用选中的值的下拉列表而不是当前搜索的下拉列表
        if (key === 'customerId') {
          item.elConfig.options.list = this.customerConditionList
        }
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      conditions.push({
        label: '车牌号',
        key: 'carId',
        matchValue: this.plateNo,
        hidden: false,
      })
      return conditions
    },
  },
}
</script>
